import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, message,Image } from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import "./index.scss"
import { getRequest } from '../../utils/request';

const buttonLayout = {
  wrapperCol: {
    offset: 10,
    span: 16
  }
}

const App: React.FC = () => {

  const [form] = Form.useForm()
  const [messageApi, contextHolder] = message.useMessage();
  const [count, setCount] = useState(60)
  const [liked, setLiked] = useState(true)
  const [imageCodeBase64, setImageCodeBase64] =  useState('');
  // 成功提示
  const success = (text: string) => {
    messageApi.open({
      type: 'success',
      content: text,
    });
  };

  // router Hooks
  const navigate = useNavigate()

  const submitData = async () => {
    const data = form.getFieldsValue()
    console.log("表单数据 (JSON格式):", JSON.stringify(data, null, 2));
    let res = await getRequest("/api/note/verCode", data)
    if (res.code == 200) {
      sessionStorage.setItem("token", res.data.token)
      sessionStorage.setItem("isLogin", "1")
      localStorage.setItem("userId", res.data.userId)
	  const roleName=res.data.roleNames;
	  if(roleName&&roleName.length>0){
	  	localStorage.setItem("roleName", roleName.join(","))
	  }else{
		  localStorage.setItem("roleName", "");
	  }
      console.log(res)
      success("登录成功")
      navigate("/home")
    }
  };
  const getCode = async () => {
    const data = form.getFieldsValue()
   console.log("接口返回数据data：", JSON.stringify(data || {}));
    if (!data.tel) {
      message.error("请输入正确的手机号!")
      return
    }
    if (!data.imageCode) {
      message.error("请输入正确的图形验证码!")
      return
    }
debugger
    try {
      // 1. 先验证图形验证码（同步执行）
      let resver = await getRequest("/api/note/verCaptchaImage", {phone:data.tel,imageCode:data.imageCode})
      if (resver.code !== 200) {
        // 图形验证码验证失败，直接返回
        message.error("图形验证码错误!")
        return
      }

      // 2. 图形验证码验证成功后，启动倒计时
      setLiked(false)
      const timer = setInterval(() => {
        setCount(old => {
          if (old === 1) {
            setLiked(true)
            clearInterval(timer)
            return 60
          } else {
            return old - 1
          }
        })
      }, 1000)

      // 3. 在倒计时启动后，获取短信验证码
      let res = await getRequest("/api/note/getCode", data)
      if (res.code === 200) {
        message.success("获取验证码成功")
      } else {
        // 如果获取验证码失败，清除倒计时
        clearInterval(timer)
        setLiked(true)
        setCount(60)
      }

    } catch (error) {
      // 异常处理
      message.error("操作失败，请重试")
    }
  }
 // 手机号输入变化时加载图形验证码
  const handlePhoneChange = (value) => {
    if (value && value.length === 11) {
      getImageCode(value);
    }
  }

  // 刷新图形验证码
  const refreshImageCode = () => {
    const data = form.getFieldsValue();
    if (data.tel && data.tel.length === 11) {
      getImageCode(data.tel);
    } else {
      message.warning("请先输入有效的手机号");
    }
  };

  // 获取图形验证码
  const getImageCode = async (id: string) => {
    try {
      let res = await getRequest("/api/note/captchaImage", { id });
      if (res.code === 200 && res.data) {
        // 兼容Base64前缀
        if (res.data.startsWith('data:image/')) {
          setImageCodeBase64(res.data);
        } else {
          const validBase64 = res.data.replace(/\s/g, '');
          const imgUrl = `data:image/jpeg;base64,${validBase64}`;
          setImageCodeBase64(imgUrl);
        }
      } else {
        message.error("获取图形验证码失败：" + (res.message || "接口返回异常"));
        setImageCodeBase64('');
      }
    } catch (err) {
      console.error("获取图像码失败：", err);
      message.error("获取图形验证码失败，请重试");
      setImageCodeBase64('');
    }
  };


  return (
    <div className='login-form'>
      {contextHolder}
      <div style={{"textAlign":"center", 'marginBottom': "10px"}}>
      <Image preview={false} width={"50px"} src={"https://icon-library.com/images/react-icon/react-icon-28.jpg"}></Image>
      <p className='name'>钧达通讯后台管理系统</p>
      </div>
      <Form
        name="normal_login"
        form={form}
      >
        <Form.Item
          name="tel"
          rules={[{ required: true, message: '请输入手机号!' }]}
        >
          <Input prefix={<UserOutlined className="site-form-item-icon" />}
           onChange={(e) => handlePhoneChange(e.target.value)}
          placeholder="手机号" />
        </Form.Item>
        <div className='code-box'>

            {/* 图形验证码行 - 核心：同一行展示 */}
            <Form.Item
              name="imageCode"
              rules={[{ required: true, message: '请输入图形验证码!' }]}
            >
              <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Input
                  placeholder="图形验证码"
                  maxLength={6}
                  size="middle"
                  style={{ flex: 1 }}
                />
                <Image
                  src={imageCodeBase64}
                  alt="图形验证码"
                  style={{
                    width: '100px',
                    height: '32px',
                    cursor: 'pointer',
                    border: '1px solid #d9d9d9',
                    borderRadius: '4px'
                  }}
                  onClick={refreshImageCode}
                  fallback="https://via.placeholder.com/100x32?text=点击刷新"
                  preview={false}
                />
              </div>
            </Form.Item>

          <Form.Item name="code"  >
             <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Input
                  prefix={<LockOutlined className="site-form-item-icon" />}
                  placeholder="验证码"
                />
                {  liked ? (<div className='get-code' onClick={getCode}>获取验证码</div>) : (<div className='get-code'>{count}秒</div>) }
                </div>
          </Form.Item>

        </div>

        <Form.Item {...buttonLayout}>
          <Button type="primary" htmlType="submit" onClick={submitData}>
            提交
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default App;